import { type FlagsManager } from '@databases/flags-types';

export const clearFlagsFromFlagsManager = (flagsManager: FlagsManager): void => {
  flagsManager.clearFlags();
  flagsManager.hideAllFlags();
};
